export default {
  upcoming: 'upcoming',
  history: 'history',
};
